// src/components/Home/Home.jsx
import React from "react";
import Header from "./Header/header";
import Main from "./Main/main";


function Coaches() {
  return (
    <div>
      <Header />
      <Main />
    </div>
  );
}

export default Coaches;
